/**
 * Yeni Kullanıcılar (/yeni-kullanicilar) ve Yeni Markalar (/yeni-markalar). Sadece efe@heyglowy.com.
 * Son bakıştan sonra gelen kayıtlar "Yeni" rozetiyle işaretlenir (son bakış bu tarayıcıda tutulur).
 * Veri /api/kullanici-takip'ten gelir (backend e-posta kilitli).
 */
import React, { useEffect, useMemo, useState } from 'react';
import { UserPlus, Building2, RefreshCw, ExternalLink } from 'lucide-react';
import { apiFetch } from '../utils/apiFetch';
import { Detay } from './KullaniciTakip';

const API = 'https://api.glowytics.com/api/kullanici-takip';

const T = {
  kart: '#FFFFFF', cizgi: '#E5E7EB', cizgi2: '#F3F4F6', yuzey: '#F8FAFF',
  metin: '#111827', metin2: '#374151', metin3: '#6B7280', mavi: '#436AEB',
  kirmizi: '#DC2626', yesil: '#059669',
};

const DONEMLER = [7, 30, 90, 365];
const IC_ALAN = /@(heyglowy|glowytics)\.com$/i;

const tarihSaat = (iso) => (iso ? new Date(iso).toLocaleString('tr-TR', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Istanbul' }) : '—');
const gunOnce = (iso) => (iso ? Math.floor((Date.now() - new Date(iso)) / 86400000) : null);
const once = (iso) => {
  const g = gunOnce(iso);
  if (g === null) return '—';
  return g === 0 ? 'bugün' : `${g} gün önce`;
};

const PLATFORM = {
  GOOGLE_ADS: 'Google Ads', GOOGLE_ANALYTICS: 'GA4', META_ADS: 'Meta Ads', META_PIXEL: 'Meta Pixel', FACEBOOK_PAGE: 'FB Sayfa',
  BUSINESS_MANAGER: 'BM', META_CATALOG: 'Meta Katalog', SEARCH_CONSOLE: 'Search Console', MERCHANT_CENTER: 'Merchant Center',
  INSTAGRAM: 'Instagram', TIKTOK_ADS: 'TikTok Ads', GBP: 'GBP', SHOPIFY: 'Shopify', PINTEREST_ADS: 'Pinterest', RTB_HOUSE: 'RTB House',
};

// Son bakış zamanı: sadece bu tarayıcıya ait bir kolaylık; okunamazsa her şey "yeni" sayılmaz.
function useSonBakis(anahtar) {
  const [onceki] = useState(() => {
    try { return localStorage.getItem(anahtar); } catch { return null; }
  });
  useEffect(() => {
    try { localStorage.setItem(anahtar, new Date().toISOString()); } catch { /* yok say */ }
  }, [anahtar]);
  return onceki;
}

async function cagir(yol) {
  const res = await apiFetch(`${API}${yol}`, { headers: { 'Content-Type': 'application/json' } });
  const govde = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(govde.error || `HTTP ${res.status}`);
  return govde;
}

function Cip({ aktif, onClick, children }) {
  return (
    <button type="button" onClick={onClick} style={{
      padding: '6px 12px', borderRadius: 999, fontSize: 13, fontWeight: 500, cursor: 'pointer',
      border: `1px solid ${aktif ? T.mavi : T.cizgi}`, background: aktif ? T.mavi : T.kart, color: aktif ? '#fff' : T.metin2,
    }}>{children}</button>
  );
}

const YeniRozet = () => (
  <span style={{ fontSize: 11, fontWeight: 700, color: '#fff', background: T.kirmizi, borderRadius: 999, padding: '2px 8px', marginLeft: 8, verticalAlign: 'middle' }}>Yeni</span>
);

const Etiket = ({ children, renk = T.metin2, zemin = T.cizgi2 }) => (
  <span style={{ display: 'inline-block', fontSize: 12, color: renk, background: zemin, borderRadius: 6, padding: '2px 8px', margin: '0 4px 4px 0', whiteSpace: 'nowrap' }}>{children}</span>
);

function Abonelik({ a }) {
  if (!a) return <span style={{ color: T.metin3 }}>—</span>;
  const deneme = a.denemeBitis && new Date(a.denemeBitis) > new Date();
  return (
    <div>
      <div style={{ color: T.metin }}>{a.durum}{a.plan ? ` · ${a.plan}` : ''}</div>
      {a.denemeBitis && <div style={{ fontSize: 12, color: deneme ? T.metin3 : T.kirmizi }}>deneme {deneme ? 'bitiyor' : 'bitti'} {tarihSaat(a.denemeBitis).split(' ').slice(0, 3).join(' ')}</div>}
    </div>
  );
}

function Iskelet({ ikon: Ikon, baslik, alt, gun, setGun, yeniSayi, oncekiBakis, hata, yukleniyor, icGizle, setIcGizle, children }) {
  return (
    <div style={{ padding: '24px 16px', maxWidth: 1240, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 4 }}>
        <div style={{ width: 40, height: 40, borderRadius: 10, background: '#EEF2FF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Ikon size={20} color={T.mavi} />
        </div>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: T.metin, margin: 0 }}>{baslik}</h1>
          <div style={{ fontSize: 13, color: T.metin3 }}>{alt}</div>
        </div>
      </div>

      {oncekiBakis && !yukleniyor && (
        <div style={{ margin: '16px 0 0', padding: '10px 14px', borderRadius: 10, fontSize: 14,
          background: yeniSayi ? '#FEF2F2' : T.yuzey, color: yeniSayi ? '#B91C1C' : T.metin2 }}>
          {yeniSayi ? <><b>{yeniSayi} yeni kayıt</b> var.</> : 'Yeni kayıt yok.'} Son bakışın: {tarihSaat(oncekiBakis)}
        </div>
      )}

      {hata && <div style={{ margin: '16px 0', padding: 12, borderRadius: 8, background: '#FEF2F2', color: '#B91C1C', fontSize: 14 }}>{hata}</div>}

      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, margin: '20px 0 16px' }}>
        {DONEMLER.map((g) => <Cip key={g} aktif={gun === g} onClick={() => setGun(g)}>Son {g} gün</Cip>)}
        <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 13, color: T.metin2, cursor: 'pointer', marginLeft: 8 }}>
          <input type="checkbox" checked={icGizle} onChange={(e) => setIcGizle(e.target.checked)} /> İç hesapları gizle
        </label>
      </div>

      {yukleniyor && !hata && <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: T.metin3, fontSize: 14 }}><RefreshCw size={14} /> Yükleniyor…</div>}
      {children}
    </div>
  );
}

const th = { textAlign: 'left', fontSize: 12, fontWeight: 600, color: T.metin3, padding: '8px 10px', borderBottom: `1px solid ${T.cizgi}`, whiteSpace: 'nowrap' };
const td = { fontSize: 13, color: T.metin2, padding: '10px', borderBottom: `1px solid ${T.cizgi2}`, verticalAlign: 'top' };

function Tablo({ basliklar, children, bos }) {
  return (
    <div style={{ background: T.kart, border: `1px solid ${T.cizgi}`, borderRadius: 12, overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 900 }}>
        <thead><tr>{basliklar.map((b) => <th key={b} style={th}>{b}</th>)}</tr></thead>
        <tbody>
          {children}
          {bos && <tr><td colSpan={basliklar.length} style={{ ...td, textAlign: 'center', color: T.metin3, padding: 24 }}>Bu dönemde kayıt yok.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

const satirStili = (yeni) => ({ cursor: 'pointer', background: yeni ? '#FFF7F7' : undefined });

export function YeniKullanicilar() {
  const [gun, setGun] = useState(30);
  const [veri, setVeri] = useState(null);
  const [hata, setHata] = useState(null);
  const [icGizle, setIcGizle] = useState(true);
  const [secili, setSecili] = useState(null);
  const oncekiBakis = useSonBakis('glowy_son_bakis_yeni_kullanicilar');

  useEffect(() => {
    setVeri(null); setHata(null);
    cagir(`/yeni-kullanicilar?gun=${gun}`).then(setVeri).catch((e) => setHata(e.message));
  }, [gun]);

  const liste = useMemo(() => (veri?.kullanicilar || []).filter((k) => !icGizle || !IC_ALAN.test(k.email)), [veri, icGizle]);
  const yeniMi = (k) => oncekiBakis && new Date(k.kayit) > new Date(oncekiBakis);

  return (
    <Iskelet ikon={UserPlus} baslik="Yeni Kullanıcılar" alt="Panele yeni kaydolanlar ve kayıttan sonra ne yaptıkları"
      gun={gun} setGun={setGun} yeniSayi={liste.filter(yeniMi).length} oncekiBakis={oncekiBakis}
      hata={hata} yukleniyor={!veri} icGizle={icGizle} setIcGizle={setIcGizle}>
      {veri && (
        <Tablo basliklar={['Kullanıcı', 'Kayıt', 'Markalar', 'Giriş', 'Sayfa', 'Son görülme', 'Abonelik']} bos={liste.length === 0}>
          {liste.map((k) => (
            <tr key={k.id} onClick={() => setSecili(k.id)} style={satirStili(yeniMi(k))}>
              <td style={td}>
                <div style={{ fontWeight: 600, color: T.metin, wordBreak: 'break-all' }}>{k.email}{yeniMi(k) && <YeniRozet />}</div>
                <div style={{ fontSize: 12, color: T.metin3, marginTop: 2 }}>
                  {k.name || 'İsimsiz'} · {k.kaynak || 'kaynak yok'}{k.dogrulandi ? '' : ' · e-posta doğrulanmamış'}
                </div>
              </td>
              <td style={{ ...td, whiteSpace: 'nowrap' }}>
                {tarihSaat(k.kayit)}
                <div style={{ fontSize: 12, color: T.metin3 }}>{once(k.kayit)}</div>
              </td>
              <td style={{ ...td, maxWidth: 260 }}>
                {k.markalar.length === 0 ? <span style={{ color: T.kirmizi }}>Marka yok</span>
                  : k.markalar.map((m) => <Etiket key={m.id} renk={m.rol === 'SAHİP' ? T.mavi : T.metin2} zemin={m.rol === 'SAHİP' ? '#EEF2FF' : T.cizgi2}>{m.ad}{m.rol === 'SAHİP' ? ' · sahip' : ''}</Etiket>)}
              </td>
              <td style={td}>{k.giris}</td>
              <td style={td}>{k.sayfa || <span style={{ color: T.metin3 }}>—</span>}</td>
              <td style={{ ...td, whiteSpace: 'nowrap' }}>{k.son_gorulme ? once(k.son_gorulme) : <span style={{ color: T.kirmizi }}>Hiç girmedi</span>}</td>
              <td style={td}><Abonelik a={k.abonelik} /></td>
            </tr>
          ))}
        </Tablo>
      )}
      {veri && <div style={{ fontSize: 12, color: T.metin3, marginTop: 12 }}>{liste.length} kullanıcı. Satıra tıklayınca giriş ve sayfa geçmişi açılır.</div>}
      {secili && <Detay id={secili} onKapat={() => setSecili(null)} />}
    </Iskelet>
  );
}

export function YeniMarkalar() {
  const [gun, setGun] = useState(30);
  const [veri, setVeri] = useState(null);
  const [hata, setHata] = useState(null);
  const [icGizle, setIcGizle] = useState(true);
  const [secili, setSecili] = useState(null);
  const oncekiBakis = useSonBakis('glowy_son_bakis_yeni_markalar');

  useEffect(() => {
    setVeri(null); setHata(null);
    cagir(`/yeni-markalar?gun=${gun}`).then(setVeri).catch((e) => setHata(e.message));
  }, [gun]);

  const liste = useMemo(() => (veri?.markalar || []).filter((m) => !icGizle || !IC_ALAN.test(m.sahip?.email || '')), [veri, icGizle]);
  const yeniMi = (m) => oncekiBakis && new Date(m.acilis) > new Date(oncekiBakis);

  return (
    <Iskelet ikon={Building2} baslik="Yeni Markalar" alt="Panelde yeni açılan markalar, kimin açtığı ve neleri bağladığı"
      gun={gun} setGun={setGun} yeniSayi={liste.filter(yeniMi).length} oncekiBakis={oncekiBakis}
      hata={hata} yukleniyor={!veri} icGizle={icGizle} setIcGizle={setIcGizle}>
      {veri && (
        <Tablo basliklar={['Marka', 'Açılış', 'Açan', 'Kullanıcılar', 'Bağlantılar', 'Kullanım', 'Abonelik']} bos={liste.length === 0}>
          {liste.map((m) => (
            <tr key={m.id} onClick={() => m.sahip?.id && setSecili(m.sahip.id)} style={satirStili(yeniMi(m))}>
              <td style={td}>
                <div style={{ fontWeight: 600, color: T.metin }}>{m.ad}{yeniMi(m) && <YeniRozet />}</div>
                <div style={{ fontSize: 12, color: T.metin3, marginTop: 2 }}>
                  {[m.sektor, m.para, m.durum !== 'ACTIVE' ? m.durum : null].filter(Boolean).join(' · ') || '—'}
                </div>
                {m.site && (
                  <a href={/^https?:\/\//.test(m.site) ? m.site : `https://${m.site}`} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}
                    style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12, color: T.mavi, textDecoration: 'none', marginTop: 2, wordBreak: 'break-all' }}>
                    {m.site.replace(/^https?:\/\//, '')} <ExternalLink size={11} />
                  </a>
                )}
              </td>
              <td style={{ ...td, whiteSpace: 'nowrap' }}>
                {tarihSaat(m.acilis)}
                <div style={{ fontSize: 12, color: T.metin3 }}>{once(m.acilis)}</div>
              </td>
              <td style={td}>
                <div style={{ color: T.metin, wordBreak: 'break-all' }}>{m.sahip?.email || '—'}</div>
                {m.sahip?.kayit && <div style={{ fontSize: 12, color: T.metin3 }}>{gunOnce(m.sahip.kayit) - gunOnce(m.acilis) <= 1 ? 'yeni kullanıcı' : `${once(m.sahip.kayit)} kayıtlı`}</div>}
              </td>
              <td style={{ ...td, maxWidth: 220 }}>
                {(m.kullanicilar || []).map((u) => <div key={u.id} style={{ fontSize: 12, wordBreak: 'break-all' }}>{u.email}<span style={{ color: T.metin3 }}> · {u.rol.toLowerCase()}</span></div>)}
              </td>
              <td style={{ ...td, maxWidth: 240 }}>
                {m.baglantilar.length === 0 ? <span style={{ color: T.kirmizi }}>Hiçbiri</span>
                  : m.baglantilar.map((p) => <Etiket key={p} renk={T.yesil} zemin="#ECFDF5">{PLATFORM[p] || p}</Etiket>)}
              </td>
              <td style={{ ...td, whiteSpace: 'nowrap' }}>
                {m.sayfa ? `${m.sayfa} sayfa` : <span style={{ color: T.metin3 }}>Kullanılmadı</span>}
                {m.son_aktivite && <div style={{ fontSize: 12, color: T.metin3 }}>son {once(m.son_aktivite)}</div>}
              </td>
              <td style={td}><Abonelik a={m.abonelik} /></td>
            </tr>
          ))}
        </Tablo>
      )}
      {veri && <div style={{ fontSize: 12, color: T.metin3, marginTop: 12 }}>{liste.length} marka. Satıra tıklayınca markayı açan kişinin geçmişi açılır.</div>}
      {secili && <Detay id={secili} onKapat={() => setSecili(null)} />}
    </Iskelet>
  );
}
